import { render, staticRenderFns } from "./BaseLearningResponseEdit.vue?vue&type=template&id=9356c45a&scoped=true&"
import script from "./BaseLearningResponseEdit.vue?vue&type=script&lang=js&"
export * from "./BaseLearningResponseEdit.vue?vue&type=script&lang=js&"
import style0 from "./BaseLearningResponseEdit.vue?vue&type=style&index=0&id=9356c45a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9356c45a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCombobox,VIcon,VListItem,VListItemContent,VListItemTitle,VTextField})
